import { render } from "./templates/index.html?vue&type=template&id=04b08ac9&external"
import script from "./script/index.js?vue&type=script&lang=js&external"
export * from "./script/index.js?vue&type=script&lang=js&external"

import "./stylesheets/index.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__